import { BACKEND_URL } from "../../../constants";

const URL = `${BACKEND_URL}/graphql`;

const QUERY = `
query (
  $refQ: String!,
  $journalQ: String!
){
  viewer {
    luJournals(first: 10, q: $journalQ) {
      edges {
        node {
          id shortName fullName
        }
      }
    }
    references(q: $refQ, first: 10) {
      edges {
        node {
          id
          author
          title
          journal
          refYear
          medlineId
          authors {
            lastname
            initials
          }
          published
        }
      }
    }
  }
}
`;


export default async function API({
  reference,
  journal}) {

  reference = reference || '';
  journal = journal || '';

  const request = new Request(
    URL,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          refQ: reference,
          journalQ: journal,
        }
      })
    });

  const resp = await fetch(request);
  const {data} =  await resp.json();

  return data;
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/api.js